import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as relay from '../../../../relay'

export const DOC = gql`
  ${relay.commands.gql.fragments.command.DOC}
  fragment FragmentQuiverEvaluationComplete on QuiverEvaluationComplete {
    commands {
      ...FragmentRelayCommand
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentQuiverEvaluationCompleteFragment,
  ents.core.quiver.Evaluation.Complete
>({
  commands: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      relay.commands.gql.fragments.command.TRANSFORMER,
      { onNullish: 'remove' },
    ),
    [],
  ),
})
